<template lang='pug'>
  .boost-modal.clearfix(v-if="selectedBoost && boostRecommendations.length")
    .title-wrap.xs-12.text-center
      p.upper.bold.xs-f-large.lg-f-xlarge.max-at-tweak Just {{selectedBoost.price | currency}}

    .nav-wrap.xs-12
      CenterSelectedNav(:labels="boostRecommendationLabels" :value="selectedBoostIndex" @input="updateSelectedBoost")

    .xs-12
      .sm-fixed-width-tweak-upper
        .product-wrap.xs-12
          .xs-fixed-width-tweak-upper
            .product-image-wrap.xs-12.md-4
              .product-image.full-width
                img.full-width(:src="selectedBoost.imagery.standard.url" :alt="selectedBoost.imagery.standard.alt_text")
                p.ribbon.upper.semi-bold.xs-f-small.md-f-xxsmall.max-at-tweak(v-if="selectedBoost.inventory_status == 'coming_soon'") coming soon
                p.ribbon.upper.semi-bold.xs-f-small.md-f-xxsmall.max-at-tweak(v-else-if="selectedBoost.inventory_status == 'backordered'") backordered
                p.ribbon.purple.upper.semi-bold.xs-f-small.md-f-xxsmall.max-at-tweak(v-else-if="selectedBoost.new") new
              
            .product-info.xs-12.md-8
              .product-desc.xs-12
                p.product-name.upper.bold.xs-f-small.lg-f-medium.max-at-tweak {{ selectedBoost.name }}
                p.color-slate.xs-f-small.lg-f-medium.max-at-tweak {{ selectedBoost.desc.short }}
                ul.product-bullets.color-slate.xs-f-small.lg-f-medium.max-at-tweak
                  li.color-slate.xs-f-small.lg-f-medium.max-at-tweak(v-for="info in selectedBoost.prodInfo") {{info}}

              .why-boost.xs-12
                p.why-boost-title.bold.xs-f-small.lg-f-medium.max-at-tweak Why Boost?
                ul.boost-reasons.flex-box.xs-f-xsmall.max-at-tweak
                  li.boost-reason.flex-1.xs-f-xsmall.max-at-tweak(v-for="(image, index) in selectedBoost.whyBoostImages" :key="image.mediaId")
                    .reason-icon
                      img.full-width(:src="image.url" :alt="image.alt_text")
                    span.color-slate.xs-f-xsmall.max-at-tweak {{ selectedBoost.whyBoostText[index] }}
              
              .how-to-use.xs-12(:class="{ open: showPDPBoostModalHowToUse }")
                .how-to-use-title-wrap.xs-12
                  button.how-to-use-title.btn-reset.upper.xs-f-small.lg-f-medium.max-at-tweak(type="button" @click="showPDPBoostModalHowToUse = !showPDPBoostModalHowToUse") how to use
                    span.icon-caret-right.color-slate.xs-f-large.max-at-tweak
                
                .how-to-use-body-wrap.xs-12
                  .how-to-use-body.xs-12
                    p.color-slate.xs-f-small.lg-f-medium.max-at-tweak Designed to be used during the coloring process or anytime your hair needs a boost, apply after shampoo to give you hair exactly what it needs.
                  
              .boost-cta.xs-12.xs-text-center.md-text-left
                template(v-if="selectedBoost.inventory_status == 'active'")
                  button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="addBoost()" :class="{ added: addingProduct || selectedBoostInNextShipment }")
                    span(v-if="selectedBoostInNextShipment")
                      span.icon-check-nobox
                      span &nbsp;added
                    span(v-else) shop pro boosts

                template(v-if="(selectedBoost.inventory_status == 'coming_soon' || selectedBoost.inventory_status == 'backordered') && !onBoostWaitlist")
                  button.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(type="button" @click="addBoostToWaitlist()") be the first to know

                template(v-else-if="selectedBoost.inventory_status != 'active' && onBoostWaitlist")
                  .on-waitlist.text-left
                    p.on-waitlist-text.xs-f-small.lg-f-medium.max-at-tweak
                      | We'll email you when this item becomes available
                      span.icon-email.xs-f-xmedium.lg-f-large.max-at-tweak

</template>

<script>
  import { mapState, mapActions } from "vuex";
  import CenterSelectedNav from "../../../CenterSelectedNav";
  import boostMixin from "../../../../mixins/boostMixin";

  export default {
    name: "BoostModal",

    components: {
      CenterSelectedNav
    },

    data() {
      return {
        showPDPBoostModalHowToUse: false
      }
    },

    mixins: [ boostMixin ],

    computed: {
      ...mapState('cart', ['addingProduct']),
    },

    methods: {
      ...mapActions('modal', ['hideModal']),

      addBoost() {
        this.hideModal();
        if (!this.selectedBoostInNextShipment) {
          this.openShipmentOptions();
        }
      }
    },

    mounted() {
      this.trackEvent('Viewed Boost Modal');
    }
  }
</script>

<style scoped lang='stylus'>
  .boost-modal
    padding 2em 0
    padding-bottom 3em
    
    .title-wrap
      padding-bottom 2em
    
    .product-wrap
      padding 1em 10%
      
      .product-image
        position relative
        overflow hidden
        
        .ribbon
          position absolute
          transform translate3D(-50%, -50%, 0) rotate(-45deg)
          top 4em
          left 4em
          background-color #d8e3f2
          padding 0.5em 3em
          min-width 15em
          text-align center
          
          &.purple
            background-color color-mr-purple
            color color-white
      
      .product-info
        padding-left 1.5em
        
        .product-name
          padding-bottom 0.5em
          
        .product-bullets
          padding 0.5em 0
          padding-left 2em
          list-style disc
          
        .why-boost
          padding 1em 0
          
          .why-boost-title
            padding-bottom 0.5em
          
          .boost-reasons
            .boost-reason
              display inline-block
              vertical-align top
              width 6.5em
              text-align center
              padding 0 2%
              
              .reason-icon
                width 4.5em
                height 4.5em
                border-radius 50%
                background-color color-mr-blue
                margin 0.5em auto
                padding 0.75em
          
        .how-to-use
          padding-top 0.5em
          padding-bottom 1.5em
          
          .how-to-use-title-wrap
            border-top 1px solid #ccc

            .how-to-use-title
              padding 0.65em 5%
              width 100%
              text-align left
              
              .icon-caret-right
                position absolute
                right 0
                top 50%
                margin-top -0.75em
                transition(transform 350ms ease)
            
          .how-to-use-body-wrap
            overflow hidden
            max-height 0
            transition(max-height 400ms ease-in-out)
            border-bottom 1px solid #ccc
            
            .how-to-use-body
              padding 1em 5%
              
              &:before
                content ''
                width 100%
                height 1px
                background-color #ccc
                position absolute
                left 0
                right 0
                top 0
              
          &.open
            .how-to-use-title
              .icon-caret-right
                transform(rotate(90deg))
                
            .how-to-use-body-wrap
              max-height 10em
        
        .boost-cta
          .on-waitlist
            width 100%
            padding 1.5em 20%
            background-color #e6eef6
            
            .on-waitlist-text
              position relative
            
              .icon-email
                position absolute
                top -0.25em
                left -2em

    @media mq-mobile
      .product-wrap
        padding 1em 0
        
        .product-image-wrap
          padding 0 5%
        
        .product-info
          padding 1em 0
          
          .product-desc
            padding 0 5%
            
          .why-boost
            padding 1em 5%
            padding-bottom 1.5em
            
            .boost-reasons
              .boost-reason
                margin-right 0
                width 5.75em
                padding 0
          
          .boost-cta
            .on-waitlist
              padding 1.5em 15%
              
    @media mq-tablet
      .product-wrap
        padding 1em 15%
        
        .product-image-wrap
          padding 0 5%
        
        .product-info
          padding 1em 0
          
          .product-desc
            padding 0 5%
            
          .why-boost
            padding 1em 5%
            padding-bottom 1.5em
            
          .boost-cta
            .on-waitlist
              padding 1.5em 20%
              
    @media mq-desktop-md
      .product-wrap
        .product-info
          .boost-cta
            .on-waitlist
              padding 1.5em 20%
            
</style>
